/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

class ConfirmationModal extends React.Component
{

  cancelModal()
  {
    this.props.closeModal(false);
  }

  confirmModal()
  {
    this.props.closeModal(true);
  }

  constructor(props)
  {
    super();

    this.cancelModal = this.cancelModal.bind(this);
    this.confirmModal = this.confirmModal.bind(this);
  }

  render()
  {
    return(  
      <Modal isOpen={this.props.modalIsOpen} toggle={this.cancelModal} autoFocus={false} >
        <ModalHeader toggle={this.cancelModal}>Please confirm this action.</ModalHeader>
        <ModalBody>{this.props.modalText}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.confirmModal}>OK</Button>
          <Button autoFocus color="secondary" onClick={this.cancelModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmationModal;
